if (!customElements.get('product-highlight')) {
  customElements.define(
    'product-highlight',
    class ProductHighlight extends HTMLElement {
      constructor() {
        super()

        this.toggle = this.querySelector('[data-highlights-expand-toggle]')
        this.content = this.querySelector('[data-highlights-expanded-content]')
        this.label = this.querySelector('[data-highlights-label]')

        if (typeof this.toggle === 'undefined' || typeof this.content === 'undefined') { return }

        this.initHighlight()
      }

      initHighlight () {
        this.toggle.addEventListener('click', () => {
          this.toggle.classList.toggle('active-toggle')
          this.label.classList.toggle('active-label')
          this.content.classList.toggle('active-highlight')
        })
      }

      toggleClick() {
        this.toggle.classList.toggle('active-toggle');
        this.label.classList.toggle('active-label');
        this.content.classList.toggle('active-highlight');
      }
    }
  );
}

if (!customElements.get('product-highlight-toggle')) {
  customElements.define(
    'product-highlight-toggle',
    class ProductHighlightToggle extends HTMLElement {
      constructor() {
        super()

        this.productHighlightToToggle = parseInt(this.dataset.productHighlight);
        this.productHighlights = document.querySelectorAll('product-highlight');

        this.initHighlight()
      }

      initHighlight () {
        this.addEventListener('click', () => {
          if (this.productHighlightToToggle && this.productHighlights) {
            this.productHighlights[this.productHighlightToToggle].toggleClick();
            this.productHighlights[this.productHighlightToToggle].scrollIntoView({ behavior: "smooth"});
          }
        })
      }
    }
  );
}
